import './index.sass'

export default function Preloader() {
    return (
        <div className="lds-ellipsis">
            <div/>
            <div/>
            <div/>
            <div/>
        </div>
    )
}